import { Component, EventEmitter, Input, Output, ViewChild, Directive, ChangeDetectionStrategy } from '@angular/core';
import * as cee from '../../Common/CeeEnvisionWebComponents';
import { PaneChild } from '../pane/pane.component';

@Component({
    selector: 'app-feature-editor',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './feature-editor.component.html',
    styleUrls: ['./feature-editor.component.css'],
    standalone: false
})
export class FeatureEditorComponent extends PaneChild {
  @Input() public title!: string;
  @Input() public getItems!: () => cee.ug.ResultInfo[];
  @Input() public addItem!: () => number;
  @Input() public deleteItem!: (id: number) => void;

  @Output() public selectedIdChange = new EventEmitter<number>();

  public items!: cee.ug.ResultInfo[];
  public selectedId!: number;

  public get canAdd() {
    return this.addItem !== undefined;
  }
  public get canDelete() {
    return this.deleteItem !== undefined;
  }

  public setSelectedId(id: number) {
    this.selectedId = id;
    this.selectedIdChange.next(id);
  }

  public selectedIdChanged(id: string) {
    this.setSelectedId(parseInt(id));
  }

  public addClicked() {
    const id = this.addItem();
    this.refreshItems();
    this.setSelectedId(id);
  }

  public deleteClicked() {
    if (this.selectedId !== undefined) {
      this.deleteItem(this.selectedId);
      this.refreshItems();
      if (this.items.length === 0) {
        this.setSelectedId(0);
        this.close();
      } else {
        this.setSelectedId(this.items[0].id);
      }
    }
  }

  protected override onVisibleChanged(visible: boolean) {
    if (visible && this.selectedId === undefined) {
      this.refreshItems();
      if (this.items.length === 0 && this.addItem) {
        this.addItem();
        this.refreshItems();
      }

      if (this.items.length > 0) {
        this.setSelectedId(this.items[0].id);
      }
    }
  }

  private refreshItems() {
    this.items = this.getItems();
  }
}

@Directive()
export class FeatureEditorChild extends PaneChild {
  @ViewChild(FeatureEditorComponent)
  private _featureEditor!: FeatureEditorComponent;

  public override get container() {
    return this._featureEditor.container;
  }

  public setSelectedId(id: number) {
    this._featureEditor.setSelectedId(id);
  }
}
